// extracted by mini-css-extract-plugin
export default {"Page":"SkyXInformationPage_Page__p7Xwh"};